import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Table, Icon } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';
import capitalize from 'capitalize';
import numeral from 'numeral';

import { withRouter } from 'react-router';

const bottomRowStyle = { fontSize: '80%', color: 'grey' };
const compactCardStyle = { padding: '5px 15px' };

const getFriendlyRole = role => capitalize.words(_.toLower(_.replace(role, '_', ' ')));
const cf = num => numeral(num).format('0,0');

const WideCampaignCard = props => {
  const {
    campaign,
    campaignPermission,
    trackedAssetsCount,
    router,
    influencersCount,
  } = props;
  const onClickListener = () => router.push(`/campaign/${campaign.id}`);
  const friendlyRole = getFriendlyRole(campaignPermission.role);
  return (
    <Card onClick={onClickListener}>
      <Card.Content style={compactCardStyle}>
        <Table fixed basic="very" singleLine compact="very">
          <Table.Body>
            <Table.Row>
              <Table.HeaderCell width={4}>{campaign.name}</Table.HeaderCell>
              <Table.Cell>
                <Icon name={_.lowerCase(campaign.currency)} />
                {cf(campaign.budget)}
              </Table.Cell>
              <Table.Cell>
                <Icon name="copy outline" color="orange" />
                {campaign.totalAssets}
              </Table.Cell>
              <Table.Cell>
                <Icon name="users" color="orange" />
                {campaign.totalInfluencers}
              </Table.Cell>
              <Table.Cell>
                {friendlyRole}
              </Table.Cell>
              <Table.Cell>{campaign.createdBy}</Table.Cell>
              <Table.Cell>
                {moment(campaign.createdDate).format('Do MMM YYYY')}
              </Table.Cell>
              <Table.Cell width={1} rowSpan={2} textAlign="right">
                <Button icon="x" color="red" inverted size="mini" />
              </Table.Cell>
            </Table.Row>
            <Table.Row style={bottomRowStyle}>
              <Table.Cell>NAME</Table.Cell>
              <Table.Cell><Icon name="money bill alternate outline" color="orange" /> BUDGET</Table.Cell>
              <Table.Cell>ASSETS</Table.Cell>
              <Table.Cell>INFLUENCERS</Table.Cell>
              <Table.Cell>ROLE</Table.Cell>
              <Table.Cell>CREATED BY</Table.Cell>
              <Table.Cell>CREATED DATE</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Content>
    </Card>
  );
};

WideCampaignCard.propTypes = {
  campaign: PropTypes.object.isRequired,
  campaignPermission: PropTypes.object.isRequired,
  trackedAssetsCount: PropTypes.number.isRequired,
  influencersCount: PropTypes.number.isRequired,
  router: PropTypes.object.isRequired,
};

export default withRouter(WideCampaignCard);



/** WEBPACK FOOTER **
 ** ./src/components/wide-campaign-card/index.js
 **/